import styled from 'styled-components';

export const HotelInfoContainer = styled.div`
  display: flex;
`;

export const HotelPreview = styled.div`
  width: 80px;
  height: 80px;
  margin-right: 15px;
  
  border-radius: 6px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const HotelContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HotelHeader = styled.header`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  
  font-size: 12px;
  line-height: 1;
  
  p {
    margin: 0;
    padding: 0;
    
    &:first-child::after {
      content: "";
      
      display: inline-block;
      vertical-align: middle;
      width: 4px;
      height: 4px;
      margin: 0 5px;
      
      background-color: currentColor;
      opacity: 0.5;
      
      border-radius: 50%;
    }
  }
  
  span {
    margin: 0 5px;
    
    font-size: 40px;
    
    opacity: 0.5;
  }
`;

export const HotelTitle = styled.h3`
  margin: 0;
  padding: 0;
  
  font-size: 16px;
  line-height: 1;
`;

export const HotelFooter = styled.div`
  display: flex;
  align-items: center;
  margin-top: auto;
  
  font-size: 12px;
  line-height: 1;
  color: ${({ theme }) => theme.blue};
  
  svg {
    fill: currentColor;
  }
  
  span {
    margin-left: 5px;
    margin-bottom: -2px;
  }
`;
